import { BareButton } from '@calendly/ui/components/bare-button';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LeftColumn } from './left_column';
import { RightColumn } from './right_column';
const labelContainerCss = "lpkp0zx";
export const LabelContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(labelContainerCss, props.className)} />;
});
const dateDropdownButtonIsPhoneCss = "d14s2x2";
const dateDropdownButtonCss = "d1d9cz04";
export const DateDropdownButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(dateDropdownButtonCss, {
    [dateDropdownButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
const dateRangeContainerIsPhoneCss = "d1l2ttjl";
const dateRangeContainerIsSULFilterCss = "d1dr9dpa";
const dateRangeContainerCss = "d1v5s45x";
export const DateRangeContainer = forwardRef((props, ref) => {
  const {
    isSULFilter
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(dateRangeContainerCss, {
    [dateRangeContainerIsPhoneCss]: isPhone,
    [dateRangeContainerIsSULFilterCss]: isSULFilter
  }, props.className)} />;
});
const checkboxLeftColumnWrapperIsPhoneCss = "chagqg6";
const checkboxLeftColumnWrapperFieldColumnCss = "c1a1fvnm";
const checkboxLeftColumnWrapperCss = "c1ofzv53";
export const CheckboxLeftColumnWrapper = forwardRef((props, ref) => {
  const {
    fieldColumn
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <LeftColumn ref={ref} {...props} className={classNames(checkboxLeftColumnWrapperCss, {
    [checkboxLeftColumnWrapperIsPhoneCss]: isPhone,
    [checkboxLeftColumnWrapperFieldColumnCss]: fieldColumn
  }, props.className)} />;
});
const checkboxRightColumnWrapperIsPhoneCss = "c1gacimj";
const checkboxRightColumnWrapperFieldColumnCss = "csh6vag";
const checkboxRightColumnWrapperCss = "cdhw0j6";
export const CheckboxRightColumnWrapper = forwardRef((props, ref) => {
  const {
    fieldColumn
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <RightColumn ref={ref} {...props} className={classNames(checkboxRightColumnWrapperCss, {
    [checkboxRightColumnWrapperIsPhoneCss]: isPhone,
    [checkboxRightColumnWrapperFieldColumnCss]: fieldColumn
  }, props.className)} />;
});
const rightColumnWrapperIsPhoneCss = "r1g4y0p";
const rightColumnWrapperCss = "rc4t4s1";
export const RightColumnWrapper = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <RightColumn ref={ref} {...props} className={classNames(rightColumnWrapperCss, {
    [rightColumnWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledLabelCss = "s1q86kha";
export const StyledLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(styledLabelCss, props.className)} />;
});
const checkboxContainerIsPhoneCss = "c1hqcj6u";
const checkboxContainerFieldColumnCss = "c1vblwo1";
const checkboxContainerCss = "can7od3";
export const CheckboxContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    fieldColumn,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(checkboxContainerCss, {
    [checkboxContainerIsPhoneCss]: isPhone,
    [checkboxContainerFieldColumnCss]: fieldColumn
  }, props.className)} />;
});
const optionWrapperCss = "o1mlhi42";
export const OptionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");